import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchema';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';

import packageJson from '../package.json';

export const ALLOWED_LANGUAGES = ['en-US', 'sv-SE'];

export const SENTRY_DSN =
  'https://8854b07ea3947b08307a3128c3b8af83@o251048.ingest.us.sentry.io/4509389108609024';

export const APP_STORE_URL = 'https://shestrong.onelink.me/a8w1/jeu234js';
export const GOOGLE_PLAY_URL = 'https://shestrong.onelink.me/a8w1/jeu234js';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'shestrong';

export const GTM_ID = 'GTM-M6RH3DPR';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://shestrong.app/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'shestrong',
  name: 'SheStrong',
  themeColor: '#ffffff',
  title: 'SheStrong',
  description: 'Get Strong Inside & Out with SheStrong',
  keywords: ['shestrong'],
  author: 'activerse.app',
};

export const INSTACART_FIREBASE_FUNCTION = 'https://instacartgenerator-7yf2wukkia-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FRISCO = false;

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;

export const FORCE_BUILD = true;
